import React, { Fragment } from "react";
import { useLocalStore } from "easy-peasy";
import { Box, Grid, FormControl, FormLabel, OutlinedInput } from "@mui/material";
import { PrimaryBtn } from "components/admin_v2/ui/Buttons";
import RouterLink from "components/admin_v2/nav/RouterLink";
import useCommonPageStyles from "components/admin_v2/common/useCommonPageStyles";
import { sessionsStore } from "./sessions/stores/sessionsStore";
import { pageRoutes } from "services/api";
import I18n from "utils/i18n.js";

const NewPassword = (_props) => {
  const cls = useCommonPageStyles();
  const [state, actions] = useLocalStore(() => sessionsStore());

  const onSubmit = () => {
    actions.requestNewPassword();
  };

  return (
    <Fragment>
      <Grid container className={cls.gridCenter}>
        <Grid item xs={6} sm={4} md={3} lg={3}>
          <Box className={cls.formSection}>
            <FormControl fullWidth>
              <FormLabel className={cls.label}>{I18n.t("sessions.form.email.label")}</FormLabel>
              <OutlinedInput
                className={cls.textField}
                value={state.email || ""}
                onChange={(e) => actions.setEmail(e.target.value)}
                name="email"
              />
            </FormControl>
          </Box>
          <Box className={cls.actionsWrapper}>
            <PrimaryBtn onClick={onSubmit} className={cls.signInBtn} disabled={!state.email}>
              {I18n.t("sessions.buttons.send_password")}
            </PrimaryBtn>
          </Box>
          <Box>
            <RouterLink className={cls.sessionsLink} to={pageRoutes.signIn()}>
              {I18n.t("sessions.links.sign_in")}
            </RouterLink>
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default NewPassword;
